const en = {
  home: "Home",
  your_clients: "Your Clients",
  sort_clients: "Sort Clients",
  all_matters: "All Matters",
  expiry_dates: "Expiry Dates",
  upcoming_expiry: "Upcoming Expiry Dates & Deadlines",
  extension_requested: "Extension Requested",
  help_center: "Help Center",
  contact_us: "Contact Us",
  contact_It: "Contact Our IT Help Desk",
  client_number: "Client Number",
  client_name: "Client Name",
  lawyer: "Lawyer",
  filter: "Filter",
  sort: "Sort",
  matter_description: "Matter Description",
  your_matters: "Your Matters",
  filter_matters: "Filter Matters",
  sort_matters: "Sort Matters",
  new_matter: "New Matter",
  total_matter: "Total Matter",
  matters: "Matters",
  matter_number: "Matter Number",
  applicant_name: "Applicant Name",
  description: "Description",
  created_on: "Created On",
  status: "Status",
  questionnaires: "Questionnaires",
  documents: "Documents",
  filter_questionnaires: "Filter Questionnaires",
  sort_questionnaires: "Sort Questionnaires",
  try_questionnaire: "Try ‘questionnaire’",
  try_work_passport: "Try ‘Work Passport’",
  try_work_permit: "Try ‘Work Permit’",
  upload_documents: "Upload Documents",
  filter_documents: "Filter Documents",
  sort_documents: "Sort Documents",
  document_name: "Document Name",
  uploaded_by: "Uploaded By",
  uploaded_on: "Uploaded On",
  download_document: "Download Document",
  download: "Download",
  downloading: "Downloading...",
  retry_upload: "Retry Failed Uploads",
  account_details: "Account Details",
  reset_password: "Reset Password",
  name: "Name",
  first_name: "First Name",
  last_name: "Last Name",
  country: "Country",
  street_address: "Street Address",
  unit_number: "Unit Number",
  town_city: "Town/City",
  province_state: "Province/State",
  postal_code_zip_code: "Postal Code/Zip Code",
  phone: "Phone",
  save_changes: "Save Changes",
  search: "Search",
  access_level: "Access Level",
  everyone_on_file: "Everyone on file",
  add_documents: "Add Documents",
  apply_to_all: "Apply to all",
  save_password: "Save Password",
  password_different_notice: "Must be different from previously used passwords.",
  password_min_length: "At least 8 Characters long.",
  password_number_special_char: "At least 1 number and 1 special character",
  password_uppercase_char: "At least 1 uppercase Character",
  old_password: "Old Password",
  new_password: "New Password",
  reenter_new_password: "Re-enter New Password",
  document_type: "Document Type",
  issue_date: "Issue Date",
  expiry_date: "Expiry Date",
  initiate_extension_matter: "Initiate Extension Matter",
  how_can_we_help: "What can we help you with?",
  request_details_placeholder: "Please provide details on your request.",
  applicant_details: "Applicant Details",
  applicant_contact: "Applicant Contact Details",
  title: "Title",
  given_names_passport: "Given Names(s) – as stated on passport",
  last_name_passport: "Last Name – as stated on passport",
  date_of_birth: "Date of Birth",
  nationality: "Nationality",
  passport_number: "Passport Number",
  email: "Email",
  telephone: "Telephone",
  applicant_documents: "Applicant Documents",
  passport_bio_page: "Passport Bio Page (for all countries of Citizenship)",
  post_secondary_education_docs: "Post-Secondary Education Docs/Certificate",
  resume: "Resume",
  resume_description: "Include all work history, job titles, description of duties, locations, dates and if employment was full-time/part-time",
  canadian_status_document: "Canadian Status Document (if applicable)",
  canadian_status_description: "Include all current and/or previous, such as Work Permits, Study Permits, TRVs, or Business Visas.",
  marriage_certificate: "Marriage Certificate (if applicable)",
  accompanying_family_documents: "Accompanying Family Members’ Documents",
  passport_bios_pages_family: "Passport Bios Pages (for all family members)",
  birth_certificates_dependants: "Birth Certificates (for all dependant children)",
  submit: "Submit",
  submit_documents: "Submit Documents",
  submitting: "Submitting...",
  active: "Active",
  in_progress: "In Progress",
  pending_review: "Pending Review",
  closed: "Closed",
  how_can_we_help_you: "How Can We Help You?",
  faqs_intro: "We've put together some commonly asked questions for you. Please click on the question links below to reveal the answers!",
  tech_question_contact: "If you have a technical question that you can’t find the answer to, please contact us at ",
  case_specific_contact: "For all case-specific questions, please contact your Lawyer or Case Analyst.",
  i_need_tech_support: "I need tech support.",
  tech_issue_instructions: "If you're experiencing any technical issues or have a question, please provide the details below along with a phone number where we can reach you.",
  it_team_contact: "A member of our IT team will get in touch with you as soon as possible during regular business hours.",
  provide_issue_details: "Please provide details on the issue you’re having",
  how_to_reset_password: "How can I reset my password?",
  reset_password_instructions: "To reset your password:",
  go_to_settings: "Go to Settings (click the x icon on the top right corner).",
  reset_password_tab: "Click on the Reset Password tab.",
  enter_passwords_note: "Enter your old and new passwords. Please note, your new password must be different from previously used passwords, and must be 8 to 50 characters long, with at least 1 number, 1 special character and 1 upper case character.",
  click_save_password: "Click Save Password.",
  accepted_file_formats: "Which file formats are accepted in the portal for document uploads?",
  accepted_file_formats_list: "We accept documents in the following file formats: .PDF, .DOC, .DOCX, .PNG, .JPG, .JPEG, .HEIC, .XLS, .XLSX, .CSV and .TXT",
  no_zipped_files: "Please do not upload zipped files.",
  how_to_pay_consultation: "How can I pay for my consultation?",
  consultation_payment_url: "To pay your Consultation fees online with your Visa or Mastercard, please go to:",
  no_amex_payment: "Please note, we do not accept payments via American Express (AMEX).",
  how_to_pay_invoice: "How can I pay my invoice for my legal fees?",
  invoice_payment_note: "You can pay your Green and Spiegel invoices online with Visa or Mastercard conveniently using the links below. Please note, we do not accept payments via American Express (AMEX).",
  invoice_payment_cad_url: "To pay your invoice in CAD, please go to:",
  invoice_payment_usd_url: "To pay your invoice in USD, please go to:",
  application_time_question: "How long will my application process take?",
  application_time_answer: "Each application is different, and as such takes a different amount of time to process. Although we can’t tell you exactly how long it will take the government to process your application, here are some tools you can use.",
  processing_time_url: "To check the average processing time based on your application type, please go to:",
  check_status_url: "Once we have submitted your application, you can check your application status online at:",
  yyyy_mm_dd: "YYYY-MM-DD",
  details_required: "Details about the request are required",
  character_limit: "Character Limit: 1,000 characters",
  telephone_length: "Telephone must be at least 10 characters long",
  check_telephone_format: "Check Telephone format",
  email_required: "Email is required",
  email_format_invalid: "Entered value does not match email format",
  invalid_format: "Invalid format",
  state_required: "State/Province is required",
  email_registered: "This email is already registered. Please use a different email.",
  select_title: "Please select a title",
  given_name_required: "Given Name(s) is required",
  last_name_required: "Last Name is required",
  street_address_required: "Street Address is required",
  town_city_required: "Town/City is required",
  country_required: "Country is required",
};

export default en;